module.exports = __webpack_public_path__ + "static/media/ic-menu.c7adf520.svg";